import { render, staticRenderFns } from "./CorCarryReq.vue?vue&type=template&id=950f6064&"
import script from "./CorCarryReq.vue?vue&type=script&lang=js&"
export * from "./CorCarryReq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports